import ErrorBoundary from '@/common/atoms/ErrorBoundary'
import { configureCrisp } from '@utils/crisp'
import { loadAnalytics } from './analytics'
import { configureErrorReporting, reportError } from '@utils/errorReporting'
import React from 'react'
import { createRoot } from 'react-dom/client'
import settings from 'src/settings'
import App from './App'

// nginx already wrote the instance's name into <title> (#105). Without nginx —
// the Vite dev server — the raw marker would stay in the tab until a page sets
// its own Title.
document.title = settings.brand.name

configureCrisp()
loadAnalytics(settings.analytics)

// Filet de sécurité cache (voir nginx.conf) : index.html est servi en
// no-store, donc un déploiement ne devrait jamais coincer un visiteur. Mais un
// navigateur qui a gardé un ancien index.html d'AVANT ce durcissement pointe
// vers des chunks hashés qui n'existent plus → l'import dynamique échoue et
// l'app reste blanche. Vite émet alors `vite:preloadError`. On recharge UNE
// fois (garde sessionStorage anti-boucle) : le no-store ramène le bon
// index.html et l'utilisateur repart, sans avoir à connaître le Ctrl+Shift+R.
window.addEventListener('vite:preloadError', () => {
  if (sessionStorage.getItem('preload-error-reloaded')) return
  sessionStorage.setItem('preload-error-reloaded', '1')
  window.location.reload()
})

// Before anything renders: an error thrown while the app boots is exactly the
// kind nobody ever hears about.
configureErrorReporting()

const root = createRoot(document.getElementById('root')!)

// The boundary sits ABOVE App, providers included: an error thrown by a
// provider is exactly the case where the white screen is total, and a boundary
// mounted underneath would never see it.
root.render(
  <ErrorBoundary onError={reportError}>
    <App />
  </ErrorBoundary>
)
